<template>
  <!-- Legacy listing settings header -->
  <header v-if="isListingSettings" class="flex items-center justify-between py-4 px-8 border-b bg-white">
    <!-- Left side - Close button for onboarding, Logo for normal -->
    <div class="text-xl font-bold flex items-center hover:cursor-pointer">
      <Logo @click="redirectToDashboard" />
    </div>

    <!-- Right side - Save Updates button for onboarding -->
    <div class="flex items-center gap-4">
      <div class="hover:bg-grey-light transition-colors hover:cursor-pointer justify-center px-2 py-2 border border-grey rounded-md">
        <button
          class="flex items-center justify-center w-5 h-5"
          @click="redirectToDashboard"
        >
          <CrossGrey />
        </button>
      </div>

      <div class="hover:cursor-pointer hover:bg-grey-light transition-colors justify-center px-2 py-2 border border-grey rounded-md">
        <button
            class="flex items-center justify-center w-5 h-5"
            @click="$emit('close')"
        >
          <EyeGrey />
        </button>
      </div>

      <button
        class="border border-grey rounded-md px-4 py-2 text-primary font-semibold text-paragraph hover:bg-grey-light transition-colors"
        @click="$emit('save')"
      >
        Save Updates
      </button>
    </div>
  </header>

  <!-- Shared top navigation for normal views -->
  <SharedTopNavigation v-else v-model="mobileMenuOpen">
    <template #items>
      <NotificationsDropdown />
    </template>
    <template #desktop-items>
      <ExpertProfileDropdown />
    </template>
  </SharedTopNavigation>
</template>

<script setup lang="ts">
import Logo from '@/assets/icons/logo.svg';
import EyeGrey from '@/assets/icons/eye-grey.svg';
import CrossGrey from '@/assets/icons/cross-grey.svg';
import SharedTopNavigation from "@/components/TopNavigation.vue";
import NotificationsDropdown from "@/components/client/NotificationsDropdown.vue";
import ExpertProfileDropdown from "@/components/expert/ExpertProfileDropdown.vue";
import { useRouter } from 'vue-router'

const router = useRouter()
const redirectToDashboard = () => {
  router.push('/expert/dashboard')
}

defineProps<{
  isListingSettings?: boolean
}>()

const mobileMenuOpen = defineModel<boolean>('mobileMenuOpen', { required: true });

defineEmits<{
  close: []
  save: []
}>()
</script>
